
import { ROUTE_TIMEZONE } from './constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  isDevModeOn: false,
  isAutoRefreshOn: true,
  isAutoZoomOn: true,
  routeTimezone: ROUTE_TIMEZONE.CLIENT_LOCAL,
  defaultModule: null,
  searchApiKey: 'DEFAULT_API_KEY',
  isApiUrlMultiline: true,
  searchLang: 'en-us',
  isBboxSearch: false,
  shareUrlCopyAs: false
};
